import { render, staticRenderFns } from "./AudioCommercialsHeader.vue?vue&type=template&id=b322031e&"
import script from "./AudioCommercialsHeader.vue?vue&type=script&lang=ts&"
export * from "./AudioCommercialsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./AudioCommercialsHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports